import { UseQueryOptions } from '@tanstack/react-query';
import { DirectMail } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useDirectMail = (directMailId: number, reactQueryOptions?: UseQueryOptions<DirectMail, Error>) =>
    useQuery(
        QueryKeys.DIRECT_MAIL_ID(directMailId),
        new PathWithID(CuredApiPaths.DIRECT_MAIL, directMailId),
        reactQueryOptions
    );

export default useDirectMail;
